module.exports = __webpack_public_path__ + "img/da.4be7246b.png";